import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 24px;
  background: #fff;
  overflow: hidden;
  position: relative;
  margin-top: 1rem;
  #players-table-container {
    display: flex;
    width: 100%;
    height: 100%;
    position: relative;
    transition: transform 0.5s ease;
  }
  .slider {
    height: 100%;
  }
  .slide {
    flex: 0 0 100%;
    transition: all 0.5s;
    position: relative;
  }

  .slide-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    padding: 20px;
    height: 100%;
    width: 90%;
    margin: auto;
  }

  .slide img {
    max-width: 100%;
    max-height: 100%;
  }
  .slider #prev,
  .slider #next {
    width: 65px;
    transform: rotate(90deg);
    border: none;
    position: absolute;
    top: calc(50% - 32.5px);
    &:hover {
      border: none;
      background: transparent;
      color: #7d6246;
    }
  }
  .slider #next {
    transform: rotate(270deg);
    right: -1.5rem;
    z-index: 10;
  }
  .slider #prev {
    left: -1.5rem;
    z-index: 10;
  }
  .slide-content .players-table-info .player-info h4 {
    margin: 0;
  }
  .slide-content .players-table-info .player-subcontent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: auto;
  }
  .slide-content .players-table-info {
    width: 100%;
    height: 70%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .slide-content .players-table-info .players-table-img-conatiner {
    border-radius: 100%;
    width: 20%;
    overflow: hidden;
    margin: 0;
  }
  .slide-content .players-table-statistics-extra {
    width: 100%;
    height: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .slide-content .players-table-statistics {
    width: 100%;
    flex-direction: column;
  }
  .slide-content .players-table-statistics .players-table-statistics-value {
    width: 100%;
    height: 10px;
  }
  .slide-content .players-table-statistics .players-table-statistics-data {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .slide-content .players-table-statistics .players-table-statistics-data p {
    margin-top: 0;
  }
  @media only screen and (min-width: 867px) {
    .content .slider {
      width: 100%;
    }
    .slide-content {
      flex-direction: row;
      justify-content: space-between;
    }
    .slide-content .players-table-info {
      width: 30%;
      flex-direction: column;
    }
    .player-subcontent {
      flex-direction: column;
    }
    .slide-content .players-table-info .players-table-img-conatiner {
      width: 50%;
    }
    .slide-content .players-table-statistics-extra {
      width: 70%;
    }
    .slide-content .players-table-statistics .players-table-statistics-value {
      height: 20px;
    }
  }
`;
